import Container from '@mui/material/Container/Container';
import Typography from '@mui/material/Typography/Typography';

export const Explorer = () => (
  <Container component="main" maxWidth="xs">
    <Typography variant="h6" color="common.black">
      Esta es la home del explorador!
    </Typography>
  </Container>
);
